import { Component, OnInit } from '@angular/core';
import { AppConstant } from '../app.constants';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor(public appConstant : AppConstant) { }

  ngOnInit() {
  }

}
